import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    // checking session
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFCFB] text-[#6B6A68] text-sm font-mono-tech tracking-[0.18em] uppercase">
        Loading…
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  return children;
}
